"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _disclosure = require("./disclosure");

var _disclosure2 = _interopRequireDefault(_disclosure);

var _collection_utility = require("common-utilities/src/collection_utility");

var _functional_utility = require("common-utilities/src/functional_utility");

var _cms_utility = require("../../../packages/common-utilities/src/cms_utility");

var _string_utility = require("common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdpBottomDisclosure = function (_React$PureComponent) {
  _inherits(PdpBottomDisclosure, _React$PureComponent);

  function PdpBottomDisclosure(props) {
    _classCallCheck(this, PdpBottomDisclosure);

    var _this = _possibleConstructorReturn(this, (PdpBottomDisclosure.__proto__ || Object.getPrototypeOf(PdpBottomDisclosure)).call(this, props));

    _this.renderPDPBottomAllDisclosures = _this.renderPDPBottomAllDisclosures.bind(_this);
    return _this;
  }

  _createClass(PdpBottomDisclosure, [{
    key: "renderMainDisclosure",
    value: function renderMainDisclosure() {
      var pdpBottomAllLargeText = (0, _functional_utility.isNilOrEmpty)(this.props.fund.disclosures.pdpBottomAllLargeText) ? [] : this.props.fund.disclosures.pdpBottomAllLargeText;

      if (!(0, _functional_utility.isNilOrEmpty)(this.props.fund.disclosures.pdpBottomAllLargeTextLiq)) {
        pdpBottomAllLargeText = [].concat(_toConsumableArray(this.props.fund.disclosures.pdpBottomAllLargeTextLiq), _toConsumableArray(pdpBottomAllLargeText));
      }

      if (!(0, _functional_utility.isNilOrEmpty)(pdpBottomAllLargeText)) {
        var renderDisclosure = _collection_utility.CollectionUtility.map(pdpBottomAllLargeText, function (disclosure) {
          return _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
        });
        return _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
              _react2.default.createElement(
                "div",
                { "data-testid": "pdpBottomAllLargeText",
                  className: " disclosure display-inline-block font-light disclaimer font-slate-grey",
                  style: { width: "100%" } },
                _react2.default.createElement(
                  "div",
                  { className: "caption display-inline-block text-justified position-relative font-italic font-bold" },
                  renderDisclosure
                )
              )
            )
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: "renderPDPBottomAllDisclosures",
    value: function renderPDPBottomAllDisclosures() {
      var _this2 = this;

      var disclosures = void 0,
          dataTest = void 0,
          additionalBottomDisclaimer = void 0;
      var _props = this.props,
          fund = _props.fund,
          breakpoint = _props.breakpoint,
          intl = _props.intl;

      if ((0, _ramda.isNil)(fund.disclosures.pdpBottomAll)) {
        return null;
      }

      if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'EXPAND_PDP_BOTTOM_DISCLOSURES')) {
        dataTest = 'expanded';
        disclosures = _collection_utility.CollectionUtility.map(fund.disclosures.pdpBottomAll, function (disclosure, index) {
          return _this2.renderDisclosureItem(index, disclosure);
        });

        if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'FUND_TYPE_SPECIFIC_PDP_BOTTOM_DISCLOSURE')) {
          additionalBottomDisclaimer = !(0, _ramda.isNil)(fund.fundTypeCode) ? _string_utility2.default.getLocalizedString(intl, "n/a", "pdp-bottom-" + this.props.role + "-" + fund.fundTypeCode.toLowerCase().replaceAll("_", "-") + "-disclaimer", { role: this.props.role, year: new Date().getFullYear() }) : null;
        } else if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'INSTITUTIONAL_PDP_BOTTOM_DISCLOSURE')) {
          additionalBottomDisclaimer = !(0, _ramda.isNil)(fund.fundCompany) ? intl.formatMessage({
            id: "pdp-bottom-institutional-" + fund.fundCompany.legalStructureCode.toLowerCase().replace("_", "-") + "-disclaimer",
            defaultMessage: "n/a"
          }) : null;
        } else if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'ROLE_FUND_COMPANY_SPECIFIC_PDP_BOTTOM_DISCLOSURE')) {
          additionalBottomDisclaimer = !(0, _ramda.isNil)(fund.fundCompany) ? _string_utility2.default.getLocalizedString(intl, "n/a", "pdp-bottom-" + this.props.role + "-" + fund.fundCompany.legalStructureCode.toLowerCase().replace("_", "-") + "-disclaimer", { role: this.props.role, year: new Date().getFullYear() }) : null;
        } else if ((0, _cms_utility.isAEM)(this.props) && _collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'LIQ_PDP_BOTTOM_DISCLOSURE')) {
          additionalBottomDisclaimer = !(0, _ramda.isNil)(fund.fundCompany) ? intl.formatMessage({
            id: "pdp-bottom-liq-" + fund.fundCompany.legalStructureCode.toLowerCase() + "-disclaimer",
            defaultMessage: "n/a"
          }) : null;
        } else if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'INDEX_FUNDS_BOTTOM_DISCLOSURE')) {
          additionalBottomDisclaimer = intl.formatMessage({
            id: "pdp-bottom-index-funds-disclaimer",
            defaultMessage: "n/a"
          });
        } else {
          additionalBottomDisclaimer = !(0, _ramda.isNil)(fund.fundCompany) ? _string_utility2.default.getLocalizedString(intl, "n/a", "pdp-bottom-" + fund.fundCompany.legalStructureCode.toLowerCase() + "-disclaimer", { role: this.props.role, year: new Date().getFullYear() }) : null;
        }

        if (!(0, _ramda.isNil)(additionalBottomDisclaimer) && additionalBottomDisclaimer !== 'n/a') {
          disclosures.push(this.renderDisclosureItem(disclosures.length, additionalBottomDisclaimer));
        }
      } else {
        dataTest = 'read-more-component';
        disclosures = _react2.default.createElement(_disclosure2.default, {
          disclosureText: fund.disclosures.pdpBottomAll,
          placementId: "pdpBottomAll",
          arialabel: "Read more about product disclosure",
          breakpoint: breakpoint });
      }

      return _react2.default.createElement(
        "div",
        { className: "container padding-bottom-45", "data-testid": dataTest + "-disclosure-pdp-all" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 margin-vertical-15" },
            disclosures
          )
        )
      );
    }
  }, {
    key: "renderDisclosureItem",
    value: function renderDisclosureItem(index, disclosure) {
      return _react2.default.createElement("div", { className: "font-light disclaimer font-slate-grey margin-bottom-15 text-justified",
        key: 'pdpBottomAll-' + index,
        dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "" + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, 'margin-top-20', '') },
        this.renderMainDisclosure(),
        this.renderPDPBottomAllDisclosures()
      );
    }
  }]);

  return PdpBottomDisclosure;
}(_react2.default.PureComponent);

exports.default = PdpBottomDisclosure;